"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../../util");

exports.defaultTypographyConfig = {
  fontFamily: '"IBM Plex Sans", sans-serif',
  lineHeight: '1.5',
  sizes: {
    html: 16,
    text: '0.8125rem',
    button: '0.875rem'
  }
};

exports.createTypography = function (pallete, customConfig) {
  var config = util_1.merge({}, exports.defaultTypographyConfig, customConfig);
  var base = {
    fontFamily: config.fontFamily,
    fontSize: config.sizes.text,
    lineHeight: config.lineHeight,
    color: pallete.text.main
  };
  var variantMap = {
    main: __assign({}, base),
    secondary: __assign({}, base, {
      color: pallete.text.secondary
    }),
    disabled: __assign({}, base, {
      color: pallete.text.disabled
    }),
    h1: __assign({}, base, {
      fontWeight: 'bold',
      fontSize: '1.5rem'
    }),
    h2: __assign({}, base, {
      fontWeight: 'bold',
      fontSize: '1.25rem'
    }),
    h3: __assign({}, base, {
      fontWeight: 'bold',
      fontSize: '1rem'
    }),
    h4: __assign({}, base, {
      fontWeight: 'bold',
      fontSize: '0.875rem'
    }),
    h5: __assign({}, base, {
      fontWeight: 'bold',
      fontSize: '0.8125rem'
    }),
    h6: __assign({}, base, {
      fontWeight: 'bold',
      fontSize: '0.75rem'
    }),
    link: __assign({}, base, {
      color: pallete.primary.main,
      fontWeight: 'bold',
      textDecoration: 'underline'
    })
  };
  return __assign({}, config, {
    variant: function variant(_variant) {
      return variantMap[_variant];
    }
  });
};